module.exports = __webpack_public_path__ + "static/img/4dc68c58c012cf3e08e671f100891c36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv8.png
// module id = aMqM
// module chunks = 1